import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';

@Component({
  selector: 'app-birth-registration-details-modal',
  standalone: false,
  templateUrl: './birth-registration-details-modal.component.html',
  styleUrl: './birth-registration-details-modal.component.scss'
})
export class BirthRegistrationDetailsModalComponent {

  form: FormGroup;
  isQueryingApplication: boolean;
  isApprovingApplication: boolean;

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<BirthRegistrationDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private apiService: ApiService,
    private formBuilder: FormBuilder,
    private authService: AuthService
  ) { }

  ngOnInit(): void {

    this.initializeForm();

    this.patchForm(this.dialogData)
  }

  initializeForm() {
    this.form = this.formBuilder.group({
      surname: [''],
      firstName: [''],
      middleName: [''],
      dob: [''],
      gender: [''],
      orderOfBirth: [''],
      typeOfBirth: [''],
      placeOfBirth: [''],
      timeOfBirth : [''],
    });
  }

  hasAccess(permissions: string[]) {
    return this.authService.hasAnyPermission(permissions)
  }

  closeModal(): void {

      this.dialogRef.close();

  }

  patchForm(data: any) {
    this.form.patchValue({
      surname: data.lastName || '',
      firstName: data.firstsName || '',
      middleName: data.middleName || '',
      dob: data.dob || '',
      gender: data.gender || '',
      orderOfBirth: data.orderOfBirth || '',
      typeOfBirth: data.typeOfDelivery || '',
      placeOfBirth: data.placeOfBirth || '',
      timeOfBirth: data.timeOfBirth || '',
    });

    this.form.disable();
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef.close({reload: true});
    });
  }

  queryApplication() {
    const formValues = this.form.value;

    this.openConfirmationModal({
      title: 'Are you sure you want to decline this application?',
      onConfirm: () => {

        this.isQueryingApplication = true;

        this.apiService.post('/workflow/get-next-approving-officer', {
          entityId: this.dialogData?.id,
          workflowName: 'BIRTH_REGISTRATION',
          type: 'QUERIED'
        }).pipe(
          finalize(() => {
            this.isQueryingApplication = false;
          })
        ).subscribe((res) => {
          if (res.success) {
            this.openSuccessModal(res.message || 'Application queried successfully')
          }
          else {
            this.openErrorModal(res?.error || res?.message);

          }
        },
          (error) => {
            this.openErrorModal(error || 'Unable to decline application');
          })
      },
      onCancel: () => console.log('Declined action cancelled'),
    });
  }

  openConfirmationModal({
    title,
    onConfirm,
    onCancel = () => { },
  }: {
    title: string;
    onConfirm: () => void;
    onCancel?: () => void;
  }) {
    this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,
      data: {
        title,
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm,
        onCancel,
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }
  approveApplication() {
    this.openConfirmationModal({
      title: 'Are you sure you want to approve this application?',
      onConfirm: () => {
        this.isApprovingApplication = true;



        this.apiService.post('/workflow/get-next-approving-officer', {
          entityId: this.dialogData?.id,
          workflowName: 'BIRTH_REGISTRATION',
          type: 'APPROVED'
        }).pipe(
          finalize(() => {
            this.isApprovingApplication = false;
          })
        ).subscribe((res) => {
          if (res.success) {
            this.openSuccessModal(res.message)
          }
          else {
            this.openErrorModal(res?.error || res?.message);

          }
        },
          (error) => {
            this.openErrorModal(error || 'Unable to approve application');
          })
      },
      onCancel: () => console.log('Approval action cancelled'),
    });
  }


}
